import { render, staticRenderFns } from "./assignedUsers.vue?vue&type=template&id=6b4c2966&"
import script from "./assignedUsers.vue?vue&type=script&lang=js&"
export * from "./assignedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports